import { CustomAlarmsFormContext } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/contexts/custom-alarms-form.context';
import { PropsWithChildren, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CustomAlarmFormMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';
import { useCustomAlarmDefinitionFetcher } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/hooks/use-custom-alarm-definition-fetcher/use-custom-alarm-definition-fetcher.hook';

export const CustomAlarmsFormProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const params = useParams<{ customAlarmId?: string }>();
    const mode: CustomAlarmFormMode = params?.customAlarmId && params.customAlarmId !== 'new' ? 'edit' : 'add';
    const { isFormLoading, customAlarmDefinition } = useCustomAlarmDefinitionFetcher({
        mode,
        customAlarmId: params.customAlarmId,
    });

    const value = useMemo(
        () => ({
            mode,
            customAlarmDefinition,
            isFormLoading,
        }),
        [mode, customAlarmDefinition, isFormLoading]
    );

    return <CustomAlarmsFormContext.Provider value={value}>{children}</CustomAlarmsFormContext.Provider>;
};
